export default "__VITE_ASSET__766f3372__"